import React from "react";
import styled from "styled-components";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { PlainButton } from "@sonder/ui/source/styled/fragments/PlainButton";
import { borders, colors } from "@sonder/ui/source/styled/theme";

interface CollapsingProps {
  isCollapsed: boolean;
}

const CollapsingHeader = styled.h3<CollapsingProps>`
  align-items: center;
  background: ${colors.white};
  border-left: ${borders.standard};
  border-radius: ${props =>
    props.isCollapsed ? "0.3rem" : "0.3rem 0.3rem 0 0"};
  border-right: ${borders.standard};
  border-top: ${borders.standard};
  border-bottom: ${props => (props.isCollapsed ? borders.standard : "none")};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  justify-content: space-between;
  margin: 0;
  padding: 0.75rem 1rem;
`;

const CollapserButton = styled(PlainButton)<CollapsingProps>`
  > svg {
    transform: ${props =>
      props.isCollapsed ? "rotate(0deg)" : "rotate(90deg)"};
    transition: transform 100ms linear;
  }
`;

const Count = styled.span`
  color: ${colors.gray6};
  font-size: 0.9rem;
  font-weight: normal;
  margin-left: 0.3rem;
  margin-top: 0.1rem;
`;

interface TaskTitleProps extends CollapsingProps {
  children?: React.ReactNode;
  count: number;
  onClick?: () => void;
  title: string;
}
export const TaskTitle = ({
  children,
  count,
  isCollapsed,
  title,
  onClick,
}: TaskTitleProps) => {
  return (
    <CollapsingHeader isCollapsed={isCollapsed}>
      <span>
        <span>{title}</span>
        <Count>{count}</Count>
      </span>
      {onClick && (
        <CollapserButton
          iconSize="1.71rem"
          isCollapsed={isCollapsed}
          onClick={onClick}
        >
          <ChevronRightIcon />
        </CollapserButton>
      )}
      {children}
    </CollapsingHeader>
  );
};
